module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Dialog', {
    staticClass: "sdkConsultDialog",
    attrs: {
      "theme": _vm.theme,
      "buttons": _vm.buttons
    },
    on: {
      "close": _vm.close
    }
  }, [(!_vm.showQr) ? _c('div', [_c('h1', {
    staticClass: "title"
  }, [_vm._v("通话须知")]), _vm._v(" "), _c('ul', [_c('li', [_c('dt', [_vm._v("发起通话")]), _vm._v(" "), _c('dd', [_vm._v("请在协商的咨询时间邀请来访者通话")])]), _vm._v(" "), _c('li', [_c('dt', [_vm._v("提醒来访者进入APP")]), _vm._v(" "), _c('dd', [_vm._v("\n          若来访者离线或太久未接听，请用私信/电话联系来访者登录APP进行咨询。\n        ")])])])]) : _c('div', {
    staticClass: "content-wrpa"
  }, [_c('v-touch', {
    staticClass: "close-btn",
    attrs: {
      "tag": "span"
    },
    on: {
      "tap": _vm.cancel
    }
  }, [_c('i', {
    staticClass: "yxl-font yxl-font-close"
  })]), _vm._v(" "), _c('img', {
    staticClass: "qr",
    attrs: {
      "src": require("../../assets/images/qr-code.png")
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("语音咨询只支持在APP上进行"), _c('br'), _vm._v("请扫码下载APP")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f5037fca!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/consultation/sdkConsultDialog.vue
// module id = 2635
// module chunks = 115